import React from 'react';
import PropTypes from 'prop-types';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { withTranslation } from 'react-i18next';
class Paginator extends React.Component {

  render(){

    const { currentPage,lastPage, onPageChange,className='', t } = this.props;

    return (
      <div className={"table-paginator "+className}>
        {<button className="pagination-button" disabled={currentPage === 1} onClick={()=>onPageChange(currentPage-1)}>
          <ArrowBackIosIcon color='094063'/>
          </button>}
          {currentPage !== 1 && <button onClick={()=>onPageChange(1)}>{t("common.quantity", { quantity: 1 })}</button>}

          {currentPage-3 > 1 && <p>...</p>}

          {currentPage-2 > 1 && <button onClick={()=>onPageChange(currentPage-2)}>{currentPage-2}</button>}
          {currentPage-1 > 1 && <button onClick={()=>onPageChange(currentPage-1)}>{currentPage-1}</button>}

          <button className="current">{t("common.quantity", { quantity: currentPage })}</button>

          {currentPage+1 < lastPage && <button onClick={()=>onPageChange(currentPage+1)}>{t("common.quantity", { quantity: currentPage+1 })}</button>}
          {currentPage+2 < lastPage && <button onClick={()=>onPageChange(currentPage+2)}>{t("common.quantity", { quantity: currentPage+2 })}</button>}

          {currentPage+3 < lastPage && <p disabled>...</p>}

          {currentPage !== lastPage && <button onClick={()=>onPageChange(lastPage)}>{t("common.quantity", { quantity: lastPage })}</button>}
        <button className="pagination-button" disabled={currentPage === lastPage} onClick={()=>onPageChange(currentPage+1)}>
          <ArrowForwardIosIcon color='094063'/>
        </button>
      </div>
    )
  }
}

Paginator.propTypes = {
  currentPage:PropTypes.number.isRequired,
  lastPage:PropTypes.number,
  onPageChange:PropTypes.func.isRequired
};

export default withTranslation()(Paginator);